import Axios, { AxiosError } from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { backgroundConcentrationKeys } from "src/query-keys";
import { APIError, BackgroundConcentration } from "src/types";

/**
 * Deserialize the json format into a Javascript object
 */
function deserialize(data: BackgroundConcentration) {
  return {
    ...data,
    dateCreated: new Date(data.dateCreated),
  };
}

export function useBackgroundConcentrations() {
  async function queryFn(): Promise<BackgroundConcentration[]> {
    const result = await Axios.get("/planning-api/background");
    return result.data.map(deserialize);
  }

  return useQuery<BackgroundConcentration[], AxiosError<APIError>>(backgroundConcentrationKeys.all, queryFn);
}

export function useBCSetAsDefaultMutation(bcId: number | string) {
  const queryClient = useQueryClient();

  async function mutationFn(id: string | number): Promise<void> {
    const response = await Axios.put(`/planning-api/background/${id}/default`);
    return response.data;
  }

  return useMutation<void, AxiosError<APIError[]>, void, unknown>(() => mutationFn(bcId), {
    onSettled: () => queryClient.invalidateQueries(backgroundConcentrationKeys.detail(bcId)),
  });
}

export function useBCDeleteMutation(bcId: number | string) {
  const queryClient = useQueryClient();

  function mutationFn(id: string | number): Promise<void> {
    return Axios.delete(`/planning-api/background/${id}`);
  }

  return useMutation<void, AxiosError<APIError[]>, void, unknown>(() => mutationFn(bcId), {
    onSettled: () => queryClient.invalidateQueries(backgroundConcentrationKeys.detail(bcId)),
  });
}
